import React, { useState, useCallback } from 'react';
import GroupSearchParams from './GroupSearchParams';
import GroupService from '../../../Services/UserGroup/GroupService';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import GroupChildItem from '../../../Domain/UserGroup/GroupChildItem';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import AddGroupChildrenWindowDescription from './AddGroupChildrenWindowDescription';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import AddGroupChildrenItem from '../../../Domain/UserGroup/AddGroupChildrenItem';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';

const GroupChildrenAdmin = ({ parentGroupId }) => {
  const initialSearchItem = new GroupSearchParams();
  initialSearchItem.ParentGroupId = parentGroupId ? parentGroupId : 0;

  const [searchItem, setSearchItem] = useState(initialSearchItem);
  // const [selectedItem, setSelectedItem] = useState(null);
  const [shownPanel, setShownPanel] = useState(ShownPanelsEnum.None);

  // const clickOnEdit = useCallback((selectedId, selectedItem) => {
  //   setSelectedItem({ ...selectedItem });
  //   setShownPanel(ShownPanelsEnum.EditItem);
  // }, []);

  // GroupItem.editFunction = clickOnEdit;

  const refresh = useCallback(
    (refreshFlag) => {
      if (refreshFlag) {
        setShownPanel(ShownPanelsEnum.None);
        setSearchItem({ ...searchItem });
      } else {
        setShownPanel(ShownPanelsEnum.None);
      }
    },
    [searchItem]
  );

  const startSearch = useCallback((newSearchItem) => {
    setSearchItem({ ...newSearchItem, ParentGroupId: parentGroupId ? parentGroupId : 0 });
  }, []);

  const renderOnePanel = (panelId, content) => (shownPanel === panelId ? content : null);

  const renderPanels = () => {
    return (
      <div>
        {renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new AddGroupChildrenItem(parentGroupId)}
            clickOnCancel={() => refresh(false)}
            clickOnSave={() => refresh(true)}
            windowDescription={AddGroupChildrenWindowDescription}
            errorCode={'GCA59'}
          />
        )}
        {/* {renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={selectedItem}
            clickOnCancel={() => refresh(false)}
            clickOnSave={() => refresh(true)}
            windowDescription={EditGroupWindowDescription}
            errorCode={'GA70'}
          />
        )} */}
      </div>
    );
  };

  const renderButtonsAndPanels = () => (
    <>
      <FigmaButtonRow
        buttons={[
          {
            type: ButtonTypeEnum.NormalNormal,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Right,
            onClick: () => setShownPanel(ShownPanelsEnum.AddNewItem),
            label: 'Add Group Children',
            tooltip: 'Add Group Children',
            roleKey: 'group_create',
            iconName: 'fa-solid fa-plus-circle',
          },
        ]}
      />
      {renderPanels()}
    </>
  );

  return (
    <div className='contentwrapper'>
      {renderButtonsAndPanels()}
      <TabOfDataTable
        clickOnStartSearch={startSearch}
        searchParamsType={GroupSearchParams}
        searchItem={searchItem}
        showSearchStrip={true}
        serviceFunction={GroupService.GetAllItemsBySearching}
        convertDBItemsFunction={GroupService.ConvertDBItems}
        shownPanel={shownPanel}
        type={GroupChildItem}
        popupEnabled={true}
        singleSearchLine={true}
        singleSearchLinePlaceholder='Search by ID, name or description'
        errorCode='GCA112'
        enableUrlPush={false}
        useClickOnClearAll={true}
      />
    </div>
  );
};

export default GroupChildrenAdmin;
